export interface TapelineModeFlags {
  /** Draw tapelines. */
  isActive: boolean
  /** Show tapelines. */
  isVisible: boolean
}

/**
 * Short-press cycle for the tapeline tool.
 * Neither exclusive state (both off, or both on) enters draw-only.
 * Draw-only and show-only then alternate.
 */
export const nextTapelineMode = ({ isActive, isVisible }: TapelineModeFlags): TapelineModeFlags => {
  if (isActive && !isVisible) return { isActive: false, isVisible: true }
  return { isActive: true, isVisible: false }
}

/**
 * Long-press for the tapeline tool.
 * Any mode that is on turns both off. Both off turns show mode on.
 */
export const longPressTapelineMode = ({
  isActive,
  isVisible,
}: TapelineModeFlags): TapelineModeFlags => {
  if (isActive || isVisible) return { isActive: false, isVisible: false }
  return { isActive: false, isVisible: true }
}
